module.exports = __webpack_public_path__ + "assets/img/00137.aa4306f4.png";